import { render } from "./page-chat.vue?vue&type=template&id=0583c50c&scoped=true"
import script from "./page-chat.vue?vue&type=script&lang=js"
export * from "./page-chat.vue?vue&type=script&lang=js"

import "./page-chat.vue?vue&type=style&index=0&id=0583c50c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0583c50c"]])

export default __exports__